import * as React from 'react';
import styled, { withTheme } from 'styled-components';
import { Link } from 'react-router';
import { rem } from 'polished';
import { SvgIcon, IconType } from '../General/SvgIcon';
import { FlexRow, FlexRowCenter } from '../../Defaults/Flexbox/Flexbox';
import { __, __r } from 'react-i18n';

interface Props {
  id?: string;
  onClick?: (e: any) => void;
  selected: boolean;
  label?: string;
  theme: any;
  name?: string;
  rounded?: boolean;
}

function AcceptTermsRegCheckbox({
  id,
  name = '',
  onClick,
  selected,
  theme,
  rounded,
}: Props) {
  const handleClick = e => {
    if (onClick) {
      onClick({
        ...e,
        target: {
          value: !selected,
          name,
        },
      });
    }
  };

  return (
    <Wrapper>
      {rounded ? (
        <Rounded active={selected} onClick={handleClick}>
          <Dot selected={selected} />
        </Rounded>
      ) : (
        <StyledBox onClick={handleClick} id={id} selected={selected}>
          <CheckIcon selected={selected}>
            <SvgIcon
              icon={IconType.checked}
              alt="Checkbox vybraný"
              width={16}
              height={16}
              viewBox="0 0 16 16"
              fill={theme.colors.white}
            />
          </CheckIcon>
        </StyledBox>
      )}
      <Label onClick={handleClick}>
        {__(
          'Súhlasím so spracovaním mojich osobných údajov prevádzkovateľom tohto e-shopu v horeuvedenom rozsahu za účelom vytvorenia užívateľského konta na e-shope prevádzkovateľa, registrácie v evidencii zákazníkov a s tým spojeného zabezpečenia plnenia objednaných tovarov a služieb',
        )}
      </Label>
    </Wrapper>
  );
}

const Wrapper = styled(FlexRow)`
  align-items: center;
  margin-right: ${rem(30)};
  margin-bottom: ${rem(10)};
  margin-top: ${rem(10)};

  ${({ theme }) => theme.mediab.s450`
    margin-top: 0;
    margin-right: 0;
  `}
`;

const CheckIcon: any = styled(FlexRowCenter)`
  width: ${rem(16)};
  height: ${rem(16)};
  display: ${(props: any) => (props.selected ? 'flex' : 'none')};
  pointer-events: none;
`;

const StyledBox: any = styled(FlexRowCenter)<{ selected?: boolean }>`
  border: ${({ theme, selected }) =>
    selected ? 'none' : theme.borders.secondary};
  background-color: ${({ theme, selected }) =>
    selected ? theme.colors.primary : theme.colors.white};
  border-radius: ${rem(4)};

  width: ${rem(24)};
  height: ${rem(24)};
  margin-right: ${rem(12)};
  transition: all 0.2s ease;
  flex-shrink: 0;

  &:hover {
    cursor: pointer;
    opacity: 0.8;
  }
`;

const Label = styled.span`
  color: ${({ theme }) => theme.colors.black};
  font-size: ${rem(12)};
  line-height: ${rem(18)};
  cursor: pointer;
  font-family: ${({ theme }) => theme.font.primary};
  text-align: left;
`;

const Rounded = styled(FlexRowCenter)<{ active: boolean }>`
  cursor: pointer;
  width: ${rem(24)};
  height: ${rem(24)};
  border-radius: 50%;
  border: ${({ theme, active }) =>
    `${active ? rem(2) : rem(1)} solid ${
      active ? theme.colors.primary : theme.colors.borderColor
    }`};
  box-shadow: ${({ theme }) => theme.boxShadow.input};
  box-shadow: ${({ theme }) => theme.boxShadow.input};
  margin-right: ${rem(16)};
`;

const Dot = styled.div<{ selected?: boolean }>`
  display: ${({ selected }) => (selected ? 'flex' : 'none')};
  width: ${rem(12)};
  height: ${rem(12)};
  background: ${({ theme }) => theme.colors.primary};
  border-radius: 50%;
`;

const LabelLink = styled(Link)`
  font-size: ${rem(13)};
  text-decoration: underline;
  color: black;
  font-family: ${({ theme }) => theme.font.secondary};
`;

const WithThemeCheckBox: any = withTheme(AcceptTermsRegCheckbox);
export { WithThemeCheckBox as AcceptTermsRegCheckbox };
